import * as $ from "jquery";
import {RegionHelper} from "../angular-modules/common/helpers/region.helper";

function initProductMedia(){
	var $productMedia = $('.js-product-media'),
		$productMediaList = $('.js-product-media-list'),
	    $productMediaItems = $('.js-product-media-item'),
		galleryimagesObject = [],
		vignetteimagesObject = [],
		roomimagesObject = [],
		lifestyleimagesObject = [],
		product360videoObject = [],
		supplementaryimagesObject = [],
		threeSixtyObject = [],
		roomimagesremObject = [],
		vignetteimagesremObject = [],
		clippedimagesObject = [],
		marketingvideoObject = [];
		

	$productMediaItems.each(function(){
		var $this = $(this),
			id = $this.data('id'),
			type = $this.data('type'),
			index = $this.index() + 1;

		//push all images to the imagesObject
		if (type === 'galleryimage') {
                galleryimagesObject.push(id);
            }else if (type === 'vignetteimage') {
                vignetteimagesObject.push(id);
            }else if (type === 'roomimage') {
                roomimagesObject.push(id);
            }else if (type === 'lifestyleimage') {
                lifestyleimagesObject.push(id);
            }else if (type === 'product360video') {
                product360videoObject.push(id);
            }else if (type === 'supplementaryimage') {
                supplementaryimagesObject.push(id);
            }else if (type === 'threesixty') {
                threeSixtyObject.push(id);
            }else if (type === 'roomimagerem') {
                roomimagesremObject.push(id);
            }else if (type === 'vignetteimagerem') {
                vignetteimagesremObject.push(id);
            }else if (type === 'clippedimage') {
                clippedimagesObject.push(id);
            }else if (type === 'marketingvideo') {
                marketingvideoObject.push(id);
			}
	});


	function isUnique(value, index, self) {
		return self.indexOf(value) === index;
	}

	var groupedGalleryImageIDs = galleryimagesObject.filter(isUnique).join(','),
		groupedVignetteImageIDs = vignetteimagesObject.filter(isUnique).join(','),
		groupedRoomImageIDs = roomimagesObject.filter(isUnique).join(','),
		groupedLifestyleImageIDs = lifestyleimagesObject.filter(isUnique).join(','),
		groupedProduct360VideoIDs = product360videoObject.filter(isUnique).join(','),
		groupedSupplementaryImageIDs = supplementaryimagesObject.filter(isUnique).join(','),
		groupedThreeSixtyIDs = threeSixtyObject.filter(isUnique).join(','),
		groupedRoomImageRemIDs = roomimagesremObject.filter(isUnique).join(','),
		groupedVignetteImageRemIDs = vignetteimagesremObject.filter(isUnique).join(','),
		groupedClippedImageIDs = clippedimagesObject.filter(isUnique).join(','),
		groupedMarketingVideoIDs = marketingvideoObject.filter(isUnique).join(',');
				
		//$productMediaList.attr({'data-image-ids' : groupedImageIDs, 'data-youtube-ids' : groupedYouTubeIDs, 'data-scene7-ids' : groupedScene7IDs, 'data-360-ids' : grouped360IDs});

	//Click function for the more images button
	$('body').on('click', '.js-more-product-media', function(e){
		$('.js-product-media-item.state-hidden').each(function(){
			var $item = $(this);
			var $itemIndex = $item.index() - 5;

			setTimeout(function(){
				$item.fadeIn(200);
			}, $itemIndex * 200);
		});

		$(this).remove();
		e.preventDefault();
	});

	// console.log(groupedImageIDs);

	//initModal(groupedImageIDs, groupedYouTubeIDs, groupedScene7IDs, grouped360IDs);
	
	initModal(groupedGalleryImageIDs, groupedVignetteImageIDs, groupedRoomImageIDs, groupedLifestyleImageIDs, 
                  groupedProduct360VideoIDs, groupedSupplementaryImageIDs, groupedThreeSixtyIDs, groupedRoomImageRemIDs, 
                  groupedVignetteImageRemIDs, groupedClippedImageIDs, groupedMarketingVideoIDs);
}


function initModal(galleryImageIDs, vignetteImageIDs, roomImageIDs, lifestyleImageIDs, product360VideoIDs, supplementaryImageIDs, threeSixtyIDs, roomImageRemIDs, vignetteImageRemIDs, clippedImageIDs, marketingVideoIDs){
	$('.js-product-media-item').each(function(){
		let $link = $(this).find('.js-product-media-link');
		let currentItemId = $(this).data('id');
		let isSingleImage;
		
		let imageIds = galleryImageIDs.concat(vignetteImageIDs, roomImageIDs, lifestyleImageIDs, supplementaryImageIDs, threeSixtyIDs, roomImageRemIDs, vignetteImageRemIDs, clippedImageIDs);
		imageIds.indexOf(",") == -1 && (product360VideoIDs.length < 1 && marketingVideoIDs.length < 1 && threeSixtyIDs.length < 1) ? isSingleImage = "&singleImage=true" : isSingleImage = "";

		var fullUrlWithParams = `?ids=${galleryImageIDs},vignetteids:${vignetteImageIDs},roomids:${roomImageIDs},lifestyleids:${lifestyleImageIDs},product360ids:${product360VideoIDs},supplementaryids:${supplementaryImageIDs},threesixtyids:${threeSixtyIDs},roomremids:${roomImageRemIDs},vignetteremids:${vignetteImageRemIDs},clippedids:${clippedImageIDs},marketingids:${marketingVideoIDs}${isSingleImage}`;
		if (currentItemId) {
			fullUrlWithParams = fullUrlWithParams.concat("&selectedItem=" + currentItemId);
		}

		if(RegionHelper.detectLanguage() === "es" || RegionHelper.detectLanguage() === "fr") {
			$link.attr('href', `/${RegionHelper.detectLanguage()}/modal${fullUrlWithParams}`);
		} else {
			$link.attr('href', '/modal' + fullUrlWithParams);
		}
	});
}

export function init() {
	initProductMedia();
}



// WEBPACK FOOTER //
// ./js/PFF/modules/productMedia.ts